import { render, staticRenderFns } from "./PxInput.vue?vue&type=template&id=90204f76&"
import script from "./PxInput.vue?vue&type=script&lang=js&"
export * from "./PxInput.vue?vue&type=script&lang=js&"
import style0 from "./PxInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports